import { render, staticRenderFns } from "./shortMessageModel.vue?vue&type=template&id=69313c39&scoped=true&"
import script from "./shortMessageModel.vue?vue&type=script&lang=js&"
export * from "./shortMessageModel.vue?vue&type=script&lang=js&"
import style0 from "./shortMessageModel.vue?vue&type=style&index=0&id=69313c39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69313c39",
  null
  
)

export default component.exports